import {useEffect, useRef} from 'react';
import {useSearchParams} from 'react-router-dom';
import {
	REGISTRATION_EDIT_INN_VALUE,
	REGISTRATION_EDIT_PARAM,
	REGISTRATION_EDIT_PASSPORT_VALUE,
	REGISTRATION_EDIT_PERSONAL_VALUE,
	REGISTRATION_EDIT_STATUSES_VALUE,
	RegistrationStep,
	WORK_STATUS_STEP_ENABLED,
} from 'features/registration';
import type {RegistrationWizardState} from './useRegistrationWizardState';

const PROFILE_EDIT_STEPS: Record<string, RegistrationStep> = {
	[REGISTRATION_EDIT_PERSONAL_VALUE]: RegistrationStep.PersonalInfo,
	[REGISTRATION_EDIT_PASSPORT_VALUE]: RegistrationStep.DocumentDetails,
	[REGISTRATION_EDIT_INN_VALUE]: RegistrationStep.IdentificationInn,
	[REGISTRATION_EDIT_STATUSES_VALUE]: RegistrationStep.WorkStatus,
};

/**
 * Вход с профиля: `?edit=personal|passport|inn|statuses` → нужный экран регистрации.
 * Назад с этого экрана и крестик — в профиль.
 */
export const useRegistrationStatusesEditEntry = (state: RegistrationWizardState) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const appliedRef = useRef(false);
	const {setOpenedFromProfileAtStatuses, setProfileEntryStep, setStep} = state;
	const edit = searchParams.get(REGISTRATION_EDIT_PARAM);
	const entryStep = edit ? PROFILE_EDIT_STEPS[edit] : undefined;
	const wantsProfileEdit = Boolean(
		entryStep !== undefined && (entryStep !== RegistrationStep.WorkStatus || WORK_STATUS_STEP_ENABLED),
	);

	useEffect(() => {
		if (appliedRef.current || !wantsProfileEdit || entryStep === undefined) {
			return;
		}

		appliedRef.current = true;
		setOpenedFromProfileAtStatuses(true);
		setProfileEntryStep(entryStep);
		setStep(entryStep);
		setSearchParams(
			(current) => {
				const next = new URLSearchParams(current);
				next.delete(REGISTRATION_EDIT_PARAM);
				return next;
			},
			{replace: true},
		);
	}, [
		entryStep,
		setOpenedFromProfileAtStatuses,
		setProfileEntryStep,
		setSearchParams,
		setStep,
		wantsProfileEdit,
	]);
};
